import React from "react";
import { Container, Row, Col } from "reactstrap";

import Highlight from "../components/Highlight";
import Loading from "../components/Loading";

import Text from "../components/Text";


import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";



export const TextSignComponent = () => {
  const { user } = useAuth0();

  return (
    <Container className="mb-5">
      <Row className="align-items-center profile-header mb-5 text-center text-md-left">
        <Col md={5}>
          <img
            src={"https://signulationassets.s3.jp-tok.cloud-object-storage.appdomain.cloud/TextToSignIcon.svg"}
            alt="Icon"
            className="rounded-circle img-fluid profile-picture mb-3 mb-md-0"
            width="300" 
            height="300"
          />

         


        </Col>
        <Col md>
          <h2>Text to Sign</h2>
          <p className="lead text-muted">Input text to generate signs</p>
        </Col>

      </Row>


      <Row >
      <Text/>
      </Row>


    </Container>
  );
};

export default withAuthenticationRequired(TextSignComponent, {
  onRedirecting: () => <Loading />,
});
